<template>
    <div>
        <div id="mt-offer-carousel" class="carousel slide carousel-fade mt-3 mt-lg-5" data-ride="carousel">

            <div class="carousel-inner" style="display: flex;">
                <offer-carousel-item-top v-for="(item, index) in carouserData"
                                         :key="item.title"
                                         v-bind:item-data="item"
                                         v-bind:index="index"/>
            </div>

            <a class="carousel-control-prev mt-md-only" href="#mt-offer-carousel" role="button" data-slide="prev">
                <span class="lazy carousel-control-prev-icon" aria-hidden="true" data-bg="/assets/mt-carousel-btn.png"></span>
                <span class="sr-only">Previous</span>
            </a>
            <a class="carousel-control-next mt-md-only" href="#mt-offer-carousel" role="button" data-slide="next">
                <span class="lazy carousel-control-next-icon" aria-hidden="true" data-bg="/assets/mt-carousel-btn.png"></span>
                <span class="sr-only">Next</span>
            </a>
        </div>

        <div class="container">
            <div class="lazy row justify-content-center pb-5" id="mt-offer-squares" data-bg="/assets/mt-template-triangle.png">
                <offer-carousel-item-bottom v-for="item in carouserData"
                                         :key="item.title"
                                         v-bind:item-data="item"/>
                <div class="col-lg-2 col-md-3 col-sm-4 col-4 mt-4">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import OfferCarouselItemTop from "@/components/home/OfferCarouselItemTop";
    import OfferCarouselItemBottom from "@/components/home/OfferCarouselItemBottom";

    export default {
        name: "OfferCarousel",
        components: {OfferCarouselItemBottom, OfferCarouselItemTop},
        props: {
            carouserData: Array
        },
        data() {
            return {}
        }
    }
</script>

<style scoped>
    .carousel-fade .carousel-item {
        transition: opacity .5s ease-in-out;
    }

    .carousel-control-prev-icon, .carousel-control-next-icon  {
        width: 30px;
        height: 30px;
    }

    .carousel-control-next-icon {
        -webkit-transform: rotate(180deg);
        -moz-transform: rotate(180deg);
        -ms-transform: rotate(180deg);
        -o-transform: rotate(180deg);
        transform: rotate(180deg);
    }

    #mt-offer-squares > /deep/div {
        padding: 0;
        margin: 10px;
    }

    #mt-offer-squares /deep/.square {
        border-width: 1px;
        border-style: solid;
        border-color: #295d92;
        background-color: #fff;
        background-repeat: no-repeat;
        background-position: center 15%;
        text-align: center;
        box-shadow: 0 2px 47px rgba(0, 0, 0, 0.1);
    }

    #mt-offer-squares /deep/.square h5 {
        position: relative;
        left: -50%;
        color: #295d92;
    }

    #mt-offer-squares {
        background-repeat: no-repeat;
        background-position: bottom right;
        background-position-x: 96%;
        background-position-y: 10%;
    }

    @media (max-width: 768px) {
        #mt-offer-squares {
            background-position-x: 80%;
            background-position-y: 90%;
        }

        #mt-offer-squares /deep/.square {
            background-size: 70%;
        }
    }

    @media (max-width: 992px) {
        #mt-offer-squares {
            background-position-x: 92%;
            background-position-y: 87%;
        }
    }
</style>